// Source/Install-Section/Storage.ts
var Key = "Install-Popup";
function readLocal() {
  const json = localStorage.getItem(Key) ?? "{}";
  return JSON.parse(json);
}
function writeLocal(storage) {
  const json = JSON.stringify(storage);
  localStorage.setItem(Key, json);
}

// Source/Install-Section/Detect.ts
function detectStore() {
  const agent = navigator.userAgent;
  if (/android/i.test(agent))
    return "Google";
  if (/iPad|iPhone|iPod/.test(agent))
    return "Apple";
  return "Other";
}

// Source/Install-Section/Track.ts
function trackClick(id) {
  console.debug("\uD83D\uDCCA Click Id:", id);
  window.lyftTrack?.("click", id);
}

// Source/Install-Section/Component.ts
class Install_Section extends HTMLElement {
  controller;
  connectedCallback() {
    this.controller = new AbortController;
    if (!this.isRelevant)
      return;
    if (this.isDebugEnabled && this.isDebugReset)
      writeLocal({ dismissed: false });
    if (this.isDismissed)
      return;
    this.dataset.store = this.store;
    this.listen();
    if (this.isDebugEnabled || this.isEnabled)
      this.open();
  }
  disconnectedCallback() {
    this.controller.abort();
  }
  close() {
    this.dismiss();
    this.$modal.close();
  }
  open() {
    this.$modal.showModal();
  }
  listen() {
    const { signal } = this.controller;
    this.$close.addEventListener("click", () => {
      this.close();
    }, { signal });
    this.$modal.addEventListener("click", (event) => {
      if (event.target === this.$modal)
        this.close();
    }, { signal });
    this.$button_google.addEventListener("click", () => {
      trackClick(this.$button_google.dataset.ablyft);
    }, { signal });
    this.$button_apple.addEventListener("click", () => {
      trackClick(this.$button_apple.dataset.ablyft);
    }, { signal });
    document.addEventListener("Install:Popup:Open", () => {
      this.open();
    }, { signal });
  }
  get isDismissed() {
    return readLocal().dismissed;
  }
  get isEnabled() {
    return document.documentElement.dataset.testShowAppPopup === "true";
  }
  get isRelevant() {
    return this.store !== "Other";
  }
  get store() {
    return this.isDebugEnabled ? this.debugStore : detectStore();
  }
  dismiss() {
    writeLocal({
      dismissed: true
    });
  }
  get isDebugEnabled() {
    return this.dataset.debugEnabled === "true";
  }
  get isDebugReset() {
    return this.dataset.debugReset === "true";
  }
  get debugStore() {
    return this.dataset.debugStore;
  }
  get $button_google() {
    return document.querySelector(`[ part = 'Badge' ][ data-type = 'Google' ]`);
  }
  get $button_apple() {
    return document.querySelector(`[ part = 'Badge' ][ data-type = 'Apple' ]`);
  }
  get $close() {
    return document.querySelector(`[ part = 'Close' ]`);
  }
  get $modal() {
    return document.querySelector(`[ part = 'Modal' `);
  }
}

// Source/Install-Section/mod.ts
customElements.define("install-section", Install_Section);
